import configuracio from "./configuracioEntorns";

const urlBase = `${configuracio.ruta}`;

export const rutaLogin = `${urlBase}/login`;
export const rutaAccessibilitat = `${urlBase}/Accessibilitat`;
export const rutaArrel = `${urlBase}/`;
export const rutaObservacions = `${rutaArrel}observacions`;
export const rutaObservadorsMapa = `${rutaArrel}observadors`;
export const rutaObservacionsIntroduccio = `${rutaObservacions}/introduccio`;
export const rutaObservacionsIntroduccioFenofasesIndividu = `${rutaObservacions}/introduccioObservacions`;
export const rutaPujarFotos = `${rutaObservacions}/introduccioPujarFotos`;
export const rutaObservacionsVisualitzacio = `${rutaObservacions}/visualitzacio`;
export const rutaObservadorsVisualitzacio = `${rutaObservadorsMapa}/visualitzacioObservadors`;
export const rutaPerfil = `${rutaArrel}Perfil`;
export const rutaCanviContrasenya = `${rutaArrel}canviarcontrasenya`;
export const rutaObservadors = `${rutaArrel}observadors`;
export const rutaIntroduccioObservador = rutaObservadors + "/introduccio";
export const rutaEdicioObservador = rutaObservadors + "/editar";
export const rutaDetallObservador = rutaObservadors + "/detall";
export const rutaAltaObservador = rutaObservadors + "/alta";
export const rutaBaixaObservador = rutaObservadors + "/baixa";
export const rutaIndrets = `${rutaArrel}indrets`;
export const rutaIntroduccioIndret = rutaIndrets + "/introduccio";
export const rutaEdicioIndret = rutaIndrets + "/editar";
export const rutaDetallIndret = rutaIndrets + "/detall";
export const rutaBaixaIndret = rutaIndrets + "/baixa";
export const rutaIndividus = `${rutaArrel}individus`;
export const rutaIntroduccioIndividu = rutaIndividus + "/introduccio";
export const rutaEdicioIndividu = rutaIndividus + "/editar";
export const rutaDetallIndividu = rutaIndividus + "/detall";
export const rutaBaixaIndividu = rutaIndividus + "/baixa";
